// extracted by mini-css-extract-plugin
export default {"formHeading":"NI-z","form":"OI-z","submitBtn":"PI-z","disabled":"QI-z","input":"RI-z","error":"SI-z","submitMsg":"TI-z","signIn":"UI-z"};